import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FooterContainer = styled.footer`
  background-color: #8b4513;
  color: white;
  text-align: center;
  padding: 2rem;
  margin-top: 3rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterText = styled.p`
  margin: 0 0 1rem 0;
`;

const SocialLinks = styled.div`
  a {
    color: white;
    margin: 0 1rem;
    transition: color 0.3s;

    &:hover {
      color: #f5f5dc;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer as={motion.footer} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
      <FooterContent>
        <FooterText>&copy; 2023 Sweet Delights Bakery. All rights reserved.</FooterText>
        <SocialLinks>
          <motion.a
            href="#"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            Facebook
          </motion.a>
          <motion.a
            href="#"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            Instagram
          </motion.a>
          <motion.a
            href="#"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            Twitter
          </motion.a>
        </SocialLinks>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;